import React from 'react';


export default function IncognitoIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.00033 13.9998L9.91499 8.6665C10.339 7.4985 10.8857 6.9305 11.727 6.9305C12.019 6.9305 13.1323 7.41717 14.2337 7.70784C15.3337 7.99984 15.211 7.26917 15.4443 7.0585C15.6777 6.84784 15.9177 6.6665 16.2577 6.6665C16.5803 6.6665 16.995 6.7305 18.5137 7.26384C19.5168 7.61469 20.4981 8.0252 21.4523 8.49317C23.019 9.26917 23.3537 9.7105 23.579 10.5025L24.667 16.6665M8.00033 13.9998C4.44477 14.5465 2.66699 15.5154 2.66699 16.9065C2.66699 21.2772 13.1163 26.6665 21.391 26.6665C27.7337 26.6665 29.3337 23.8225 29.3337 21.5758C29.3337 19.8092 27.4483 17.8638 24.667 16.6665M8.00033 13.9998C8.00033 15.2918 13.8537 18.6665 20.667 18.6665C22.419 18.6665 24.667 18.7505 24.667 16.6665" stroke="#071013" strokeOpacity="0.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

  )
}
